/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';

import { urlFor } from '../../../lib/sanity';

import PeopleBlocksStyles from '../../../styles/elements/people/PeopleBlocksFlat.module.scss';

import React from 'react';

const PeopleBlocks = ({ person, headingColor, borderColor }) => {


  return (
    <div className={PeopleBlocksStyles.profile_holder}>
      <div className={PeopleBlocksStyles.profile} style={{ borderColor: `${borderColor}` }}>
        <Link href={`/people/${person.slug.current}`}>

          <img src={urlFor(person?.image).auto('format').width(300).height(300).url()} alt={person?.name} className={PeopleBlocksStyles.imgclass} width="300" height="300" />

        </Link>
      </div>
      <Link href={`/people/${person.slug.current}`}>

        <h2 className={PeopleBlocksStyles.name} style={{ color: `${headingColor}` }}>
          {person?.name}
        </h2>

      </Link>
    </div>
  );
};



export default PeopleBlocks;
